<template lang="pug">
  #login
    appHeader
    .container-width
      router-view
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'ErrorsComponent',
  components: {
    appHeader
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>
